// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__3Ju0G","productName":"Table_productName__3u9ud"};